import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledAlert = styled(Box)<{
  borderColor: string;
  width: string;
  maxWidth: string;
  background: string;
  color: string;
}>`
  font-family: var(--font-family);
  width: ${({ width }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  border: ${({ borderColor }) => '1px solid ' + borderColor};
  padding: 16px;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;

  .material-symbols-outlined {
    font-family: 'Material Symbols Outlined';
    display: inline-block;
    line-height: 1;
    font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;

    &.error {
      color: #e38c8c;
    }

    &.success {
      color: #ccebcd;
    }
  }

  .text {
    font-size: 14px;
    font-weight: 400px;
    line-height: 20px;
  }
` as any;
